function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 0.333252H15C15.5523 0.333252 16 0.780967 16 1.33325V9.99992C16 10.5522 15.5523 10.9999 15 10.9999H9.33333L9.63333 11.5933C9.85849 12.0464 10.3207 12.333 10.8267 12.3333H11C11.1841 12.3333 11.3333 12.4825 11.3333 12.6666V13.3333C11.3333 13.5173 11.1841 13.6666 11 13.6666H5C4.81591 13.6666 4.66667 13.5173 4.66667 13.3333V12.6666C4.66667 12.4825 4.81591 12.3333 5 12.3333H5.17333C5.6793 12.333 6.14151 12.0464 6.36667 11.5933L6.66667 10.9999H1C0.447715 10.9999 0 10.5522 0 9.99992V1.33325C0 0.780967 0.447715 0.333252 1 0.333252ZM1.33333 8.33325H14.6667V1.66659H1.33333V8.33325Z",
  fill: "#2F7067"
});

var SvgScreen = function SvgScreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/screen.fc10a000.svg";
export { ForwardRef as ReactComponent };